<template>
<v-container fluid>

  <!-- <div>  -->
  <!-- <v-container fluid align-start ma-0 pa-2 class="container-height"> -->
      <v-row no-gutters fill-height>
          <v-col cols="12">
              <i-card-vertical headerTitle="Searching Ship List"  > </i-card-vertical>
                  <template>
                      <!-- <v-layout column overflow-auto> -->
                          <v-row class="d-flex">
                            <!-- <v-col cols="12" > -->
                                <!-- <v-card class="d-flex align-center justify-center"  min-height="40" outlined> -->
                                    <v-col cols="6" ms="6" md="4" class="mt-2 mb-0">
                                        <v-select 
                                          label= "Ship Div" v-model="shipDiv.select" :items="shipDiv.items" item-text="name" item-value="cd" return-object
                                          outlined dense/>
                                    </v-col> 
                                    <v-col cols="6" ms="6"  md="4" class="mt-2 mb-0">                                                    
                                    <v-text-field 
                                        label= "Ship no" v-model="shipNo"  dense  outlined  hide-details="auto"  @keyup="uppercase" />                                                    
                                    </v-col>                                                                                                
                                    <v-col cols="6" ms="6" md="4" class="mt-2 mb-0">
                                      <v-btn  block class="mx-sm-2" small color="green" @click="btnRetrieve">
                                         Retrieve
                                      </v-btn>
                                  </v-col>
                                <!-- </v-card> -->
                            <!-- </v-col> -->
                          </v-row>
                          <v-row dense> <!-- </v-row>no-gutters class="mx-0 mb-0">  -->                                                        
                                <v-col cols="12" ms="8" md="4" v-for="(shiplist, i) in shiplist" :key="i">
                                    <v-card  class="mx-auto rounded-xl mt-3" height = "240" color= "teal lighten-5" flat outlined >  
                                      <v-img
                                        height="40" 
                                        :src="require(`@/assets/images/v20/shipInfor.png`)" 
                                        cover class="text-white"
                                      >
                                        <v-toolbar color="rgba(0, 0, 0, 0)" theme="dark" >
                                          <v-toolbar-title class="text-h6">  {{ shiplist.shipNo }} </v-toolbar-title>                                          
                                          </v-toolbar>
                                      </v-img>
                                      <div >
                                        <v-row no-gutters class="mx-2 mb-2">
                                          <v-col cols="12" align = 'left'>
                                            <v-card-title class="text-h5">{{ shiplist.shipDesc }} </v-card-title>                              
                                            <v-card-subtitle class="mt-0">   Series No: {{ shiplist.seriesNo }} - Dock: {{ shiplist.dock }} -Owner: {{ shiplist.owner }} 
                                            </v-card-subtitle>
                                          </v-col>                                         
                                        </v-row>
                                        
                                      </div> 
                                      <div>
                                        <v-row no-gutters class="mx-2 mb-2">
                                          <v-col cols="12">
                                            <v-card-actions >                        
                                              <v-btn class="mx-2 " fab dark small color="green">
                                                <v-icon dark @click="picInfor(shiplist.shipNo)">mdi-account-key</v-icon>
                                              </v-btn>
                                              <v-spacer/>
                                              <v-btn class="mx-2 " fab dark small color="green"  >
                                                <v-icon dark @click="shipInfor(shiplist.shipNo)"> mdi-information-outline </v-icon>                                           
                                              </v-btn>
                                            </v-card-actions>
                                          </v-col>                                         
                                        </v-row>
                                        
                                      </div>                 
                                      
                                    </v-card>            
                                </v-col>
                              
                          </v-row>
                      <!-- </v-layout> -->
                  </template>
              <!-- </i-card-vertical> -->
          </v-col>
      </v-row> 

      <v-btn v-scroll="onScroll" v-show="fab" fab dark fixed bottom right color="green" @click="toTop">
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>

      <!-- <v20a10000detail :showShipDetail.sync="showDetail" :shipNo="asShipNo"  />
      <v20a10000pic :showPic.sync="showPic" :shipNo="asShipNo"   /> -->
        <v-dialog
            v-model="dialogShip"
            width="500">
            <DxScrollView                 height="100%"
                    width="100%">
            <v-card>    
               <v-row class="headline green" primary-title>
                <v-card-title >
                  {{shipDetail.shipNo}} Detail Information
                </v-card-title>  
                <v-spacer/>
                <v-card-actions class="pa-5">
                    <!-- <v-btn class="ml-auto" @click="btShip()" outlined color="primary">OK</v-btn> -->
                    <v-btn color="green"  @click="btShip()" >
                      <v-icon dark>
                        mdi-close-circle-outline
                      </v-icon>
                  </v-btn>

                </v-card-actions>
              </v-row>                            
                <!-- <v-card-text > -->
                    <v-row class="mt-0">
                      <v-col cols="12">
                        <v-text-field v-model=shipDetail.shipDesc label="Description" outlined readonly height="25px" dense></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">                       
                      <v-col>
                        <v-text-field v-model=shipDetail.seriesNo label="Seri No"  outlined readonly height="25px" dense></v-text-field>       
                      </v-col>
                      <v-col>
                        <v-text-field v-model=shipDetail.skind label="Ship Kind" outlined readonly height="25px" dense></v-text-field>       
                      </v-col>
                      <v-col>
                        <v-text-field v-model=shipDetail.dock label="Dock" outlined readonly height="25px" dense ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">
                      <v-col>
                        <v-text-field v-model=shipDetail.owner label="Owner/ Class" outlined readonly height="25px" dense></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field v-model=shipDetail.shipbuildgubun label="Const. Method" outlined readonly height="25px" dense></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">
                      <v-col>
                        <v-text-field v-model=shipDetail.slengh label="L.O.A/L.B.P" outlined readonly height="25px" dense></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field v-model=shipDetail.sbreath label="Breadth" outlined readonly height="25px" dense></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">
                      <v-col>
                        <v-text-field v-model=shipDetail.wcDate label="WC Date" outlined readonly height="25px" dense></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field v-model=shipDetail.klDate label="KL Date" outlined readonly height="25px" dense></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">
                      <v-col>
                        <v-text-field v-model=shipDetail.lcDate label="LC Date" outlined readonly height="25px" dense></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field v-model=shipDetail.dlDate label="DL Date" outlined readonly height="25px" dense></v-text-field>
                      </v-col>
                    </v-row>                                      
                <!-- </v-card-text> -->
                
            </v-card>
          </DxScrollView>
        </v-dialog>

        <v-dialog  v-model="dialogPic" scrollable>         
          <v-card>
            <v-row class="headline green" primary-title>
                  <v-card-subtitle >
                    Ship's Incharge
                  </v-card-subtitle>  
                  <v-spacer/>
                  <v-card-actions class="pa-5">                    
                      <v-btn color="green"  @click="btPIC()" >
                        <v-icon dark>
                          mdi-close-circle-outline
                        </v-icon>
                    </v-btn>

                  </v-card-actions>
            </v-row> 
            <template>
              <DxScrollView height="100%" width="100%"> 
                <v-row class="mt-0 mb-0" >
                  <v-col  cols="12" xs="12" sm="6" md="4"
                        v-for="(detailPIC, i) in detailPICs"  :key="i"  >
                                <v-card class="green darken-0"  outlined prepend-icon="mdi-home">                                
                                  <v-card-subtitle>
                                    <div class="mt-1 text-subtitle-2">{{detailPIC.vnmAbb }} - {{detailPIC.empNo }}</div>                                  
                                  </v-card-subtitle>
                                  <v-list subheader three-line>
                                    <v-list-item>
                                      <v-list-item-avatar>
                                        <v-img :src="detailPIC.empPic"></v-img>
                                      </v-list-item-avatar>
                                      <v-list-item-content>
                                        <v-list-item-subtitle>{{ detailPIC.posNm }} - {{ detailPIC.deptNm }}</v-list-item-subtitle>
                                        <v-list-item-subtitle>
                                          <div class="text-caption">Mobile: {{detailPIC.mobile }} - Ext: {{detailPIC.tel }}</div>
                                        </v-list-item-subtitle>                                      
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-list>                                
                            </v-card>
                  
                  </v-col>                                
                </v-row>
              </DxScrollView>  
            </template> 
          </v-card>    
        </v-dialog>

   <VueToastify :notifyAction="notifyAction"></VueToastify>
  </v-container>
  <!-- </div>   -->
</template>

<script>


import { DxScrollView } from "devextreme-vue/scroll-view";
import ICardVertical from '@/components/common/iCardVertical.vue'
import {getv20a1000, getShipPic, getEmpPic, chkShipPic} from '@/api/view/pp/20/v20a1000.js' 
import VueToastify from '@/components/toastify/VueToastify.vue'
import baseview from '@/components/base/baseview.vue'

export default {
  mixins: [baseview],
  components: { 
      ICardVertical, VueToastify,   
      DxScrollView             
    },
  data: () => ({     
    fab: false,
    shiplist: [],    
    shipDetail:{},
    shipDiv: {
                select: { name: 'All', cd: '%' },
                items: [
                    { name: 'Working', cd: '2' },
                    { name: 'Sail Out', cd: '3' },
                    { name: 'Plan', cd: '1' },                    
                ]
            },
    shipNo :'',
    asShipNo :'' ,
    dialogPic: false,
    dialogShip: false,
    detailPICs: [] ,
    chk: 'N'   
  }),   
  methods: {

    uppercase(){      
        this.shipNo = this.shipNo.toUpperCase()
      },

      picInfor (asshipNo) {      
        
        let param = {
          shipNo:    asshipNo         
        } 
        
         chkShipPic(param).then(res => {          
            this.chk = res.list[0].chkPic
          })

        console.log(this.chk)  

        if (this.chk =='Y') {  
          this.doSearchPICList(asshipNo)      
          this.dialogPic = true        
        }  
        else
        {
          this.vToastify(this.$t('Not yet input Ship PIC.'), 'warn')
          return
        }
      },

      shipInfor (asshipNo) {  
        this.doGetShipDetail(asshipNo.toUpperCase())      
        this.dialogShip = true        
        
      },
      btShip() {
        this.dialogShip = false
      },

      
      btPIC() {        
        this.dialogPic = false
      },
      
      btnRetrieve(){     
        this.doSearchShipList()
      },

      async doSearchPICList(asshipNo){

          let params = {            
            shipNo: asshipNo
          } 

          await getShipPic(params).then(res => {         

              let list = []
              let cnt = 1;
              res.list.forEach(e => {
                let params = {
                  deptCd: "",
                  grpCd: "",
                  appCd: "",
                  empNo: e.empNo,
                }                
                getEmpPic(params).then(res => {
                  this.empPic = res.body;                  
                  
                }).finally(() => {

                  list.push(
                      {
                          id: cnt++, empNo: e.empNo, mobile: e.mobile, deptNm: e.deptNm, deptCd: e.deptCd, 
                          vnmAbb: e.vnmAbb, tel: e.tel, posNm: e.posNm,
                          empPic:  this.empPic 
                         
                      }
                  )
            // 
                })
                              
                  
              });              
              this.detailPICs = list  

              

          }).finally(() => {
            // 
          })

          },  

      async doSearchShipList(){

            let params = {
              shipGu: this.shipDiv.select.cd,                 
              shipNo: this.shipNo
            } 

            await getv20a1000(params).then(res => {
                 res.list.forEach(e => {
                 e.id = e.rnum
              });        
            this.shiplist = res.list
          
            }).finally(() => {
              // 
            })

        },  

        async doGetShipDetail(asShipNo){
          
          let params = {
            shipGu: '%',                 
            shipNo: asShipNo
          } 

          await getv20a1000(params).then(res => {
              res.list.forEach(e => {
              e.id = e.rnum
            });        
          this.shipDetail = res.list[0]

          }).finally(() => {
            // 
          })

          },   


          getEmpPicture(empno) {
              try {
                // this.openLoading('searching')
                let params = {
                  deptCd: "",
                  grpCd: "",
                  appCd: "",
                  empNo: empno,
                }
                getEmpPic(params).then(res => {
                  this.empPic = res.body;
                  // console.log('res', res.body);
                  return res.body;
                  
                })

              } finally {
                // this.endLoading()
              }
      },

      onScroll(e) {
          if (typeof window === 'undefined') return
          const top = window.pageYOffset || e.target.scrollTop || 0
          this.fab = top > 20
        },
        toTop() {
          this.$vuetify.goTo(0)
      },

      notifyAction(notifyInfo, action) {
      this.$EventBus.$emit(`${this.$route.meta.menu_id}_notifyAction`, { notifyInfo: notifyInfo, action: action })
    },

    },

};
</script>

<style scoped>
.col-xl, .col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg, .col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md, .col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm, .col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col, .col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
    width: 100%;
    padding: 3px;
}

.container {
    width: 100%;
    padding: 2px;
    margin-right: auto;
    margin-left: auto;
}

</style>